import { Button, ButtonGroup, Subtitle, FlexContainer, BodyText, ReapitLogo, elMb7 } from '@reapit/elements'
import { LoginContainer, LoginContentWrapper } from './__styles__'
import { reapitConnectBrowserSession } from '@reapit-sales/reapit-connect'

export const handleLoginClick = () => {
  reapitConnectBrowserSession.connectLoginRedirect()
}

export const LoginPage = () => {
  return (
    <LoginContainer>
      <LoginContentWrapper>
        <ReapitLogo className={elMb7} height="40px" width="200px" />
        <FlexContainer isFlexColumn>
          <Subtitle hasCenteredText>Welcome</Subtitle>
          <BodyText hasCenteredText>Foundations App</BodyText>
        </FlexContainer>
        <ButtonGroup>
          <Button onClick={handleLoginClick} variant="primary" size="medium">
            Login With Reapit
          </Button>
        </ButtonGroup>
      </LoginContentWrapper>
    </LoginContainer>
  )
}
